import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

    
    Submit:{
        k: "preferences.submit",
        v: "Submit"
    }
});


// WEBPACK FOOTER //
// ./src/panels/recommended/userPreferences/UserPreferences.labels.ts